import api from 'api';

export const SET_DESIGN_IMPORT_RECORD = 'SET_DESIGN_IMPORT_RECORD';
export const RESET_DESIGN_IMPORT_DATA = 'RESET_DESIGN_IMPORT_DATA';
export const DESIGN_IMPORT_ACTION_START = 'DESIGN_IMPORT_ACTION_START';
export const DESIGN_IMPORT_ACTION_FAILURE = 'DESIGN_IMPORT_ACTION_FAILURE';

/**
 * set loading state
 * @returns
 */
const designImportRecordActionStart = () => ({
  type: DESIGN_IMPORT_ACTION_START,
});

/**
 * end loading on errors
 * @param {String} message error message
 * @returns
 */
const designImportRecordActionFailure = (message) => ({
  type: DESIGN_IMPORT_ACTION_FAILURE,
  data: message,
});

/**
 * Initiates set design-import data action
 * @param {Object} data design-import record
 * @returns
 */
const setDesignImportRecordData = (data) => ({
  type: SET_DESIGN_IMPORT_RECORD,
  data,
});

/**
 * resets the state
 * @returns
 */
export const resetDesignImportData = () => ({
  type: RESET_DESIGN_IMPORT_DATA,
});

/**
 * fetches the design-import data by designId
 * @param {Number} designId design id
 * @returns
 */
export function fetchDesignImportRecordAsync(designId) {
  return (dispatch) => {
    dispatch(designImportRecordActionStart());
    return api
      .request(`design/designImport/${designId}`, 'get')
      .then((data) => {
        return dispatch(setDesignImportRecordData(data));
      })
      .catch((err) => {
        dispatch(
          designImportRecordActionFailure('Failed to fetch Design Import data')
        );
        throw err;
      });
  };
}
